// 能耗分析
import {
    Style
} from '@/libs/style.js';

let template = /*html*/ `<div class="app-nhmonitor">
<div class="app-nhmonitor-header">
     <!--<img src="./images/default/2.png" alt="">-->
    <h2>能耗分析</h2>
    <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
</div>
<div class="chart-box">
<div class="y-name">kwh</div>
<dv-charts :option="option" />
</div>
    <!--<dv-decoration-6 style="width:80%;height:60%;margin:auto;margin-top:20px;" />-->
    
</div>`;


let style = /* css */ `.app-nhmonitor{
    position: absolute;
    top: 66%;
    right: 1%;
    width: 25%;
    background: rgba(0,0,0,0.2);
    height: 30%;
    overflow: hidden;
}
.app-nhmonitor .chart-box{
    height:74%;
    position:relative;
}
.app-nhmonitor .chart-box .y-name{
    position:absolute;
    font-size:12px;
    left:18px;
    top:5px;
    color:#fff;
}
.app-nhmonitor .app-nhmonitor-header{
    padding-left:15px;
    background:linear-gradient(to right,#159AFF80,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
    position:relative;
}
.app-nhmonitor .app-nhmonitor-header img{
    margin:0 15px;
}

.app-nhmonitor .tab-section{
    padding:0 20px;
    color:#fff;
}
.app-nhmonitor .tab-item{
    color:#fff;
}
.app-nhmonitor .el-tabs__item{
    color:#fff;
}
`;

export default (Vue) => {
    Vue.customElement('xbt-app-nhmonitor', {
        template: template,
        data() {
            return {
                activeName: 'malfunction',
                option: {
                    title: {
                        show: false
                    },
                    xAxis: {
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],

                    },
                    yAxis: {
                        // name: 'kwh',
                        data: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        nameTextStyle: {
                            fill: '#fff',
                            fontSize: 10
                        }
                    },
                    colors: ['rgba(55, 162, 218, 0.6)'],
                    grid: {
                        top: 30,
                        bottom: 18,
                        style: {
                            fill: 'rgba(0, 0, 0, 0)',
                        }
                    },
                    series: [
                        {
                            smooth: true,
                            data: [50, 60, 42, 57, 52, 55, 57],
                            type: 'bar',
                            gradient: {
                                color: ['#37a2da', '#67e0e3']
                              }
                        }
                    ]
                }
            }
        },
        created(){
            this.mock = this.$Core.getProvider('Mock')
            this.init()
        },
        mounted() {
            Style(style);
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            async init(){
                /**
                 * @type {Array}
                 */
                let data=await this.mock.getNHMonitor()
             
                let options =  {
                    title: {
                        show: false
                    },
                    xAxis: {
                        data: [],

                    },
                    yAxis: {
                        // name: 'kwh',
                        data: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        nameTextStyle: {
                            fill: '#fff',
                            fontSize: 10,
                        }
                    },
                    colors: ['rgba(55, 162, 218, 0.6)'],
                    grid: {
                        top: 30,
                        bottom: 18,
                        style: {
                            fill: 'rgba(0, 0, 0, 0)',
                        }
                    },
                    series: [
                        {
                            smooth: true,
                            data: [],
                            type: 'bar',
                            gradient: {
                                color: ['#37a2da', '#67e0e3']
                              }
                        }
                    ]
                }
                let month = new Date().getDate()
                data.forEach((item,index)=>{
                    if(index < (month-1)){
                        options.xAxis.data.push(item.date+'日');
                        options.series[0].data.push(item.value)
                        if(options.xAxis.data.length>7){
                            options.xAxis.data.shift()
                        }
                        if(options.series[0].data.length>7){
                            options.series[0].data.shift()
                        }
                    }
                    
                })

                this.option = options
            }
        }
    });
}